export default __webpack_public_path__ + "static/media/propsal-icon-card.816ba047.svg";